import React, {useState} from 'react';
import { Table, Space, Tooltip } from 'antd';
import { 
  TableWrapper, 
  StudentEditModal, 
  StudentHistoryModal,
  B2cMailSendModal,
  B2cMultiSmsSendModal, 
  CompanyEditModal } from 'components/molecules';
import { usePopupManager } from 'react-popup-manager';
import { ColumnsType } from 'antd/lib/table/interface';
import { CarryOutOutlined, WarningOutlined, SendOutlined, UnorderedListOutlined } from '@ant-design/icons'
import { Button } from 'components/atoms'

interface FormItemProps {
  info: LectureInfoDto;
  group: string;
  studentList: StudentListDto[];  
  refetch: () => void;
}

const ReinforceTable = ({info, group, studentList, refetch}: FormItemProps): React.ReactElement => {
  /* ======================================================
   * variables
   * ====================================================== */
  const { open } = usePopupManager();
  const [selectedRowKeys, setRowKeys] = useState<any>([]);
  const [selected, setSelectd] = useState<number[]>();
  const [selectedStudent, setSelectdStudent] = useState<string[]>();

  const onRowClick = (record) => {
    return {
      onClick: () => {
        open(StudentEditModal, { 
          id: record.id,
          group: group,
          lectureInfo: info,
          refetch: refetch,
          onClose: (isOk) => {
            if (isOk) {   
              refetch();
            };
          },          
        }); 
      },
    };
   };

  const columns: ColumnsType<StudentListDto> = [
    {
      title: '번호',
      key: 'num',
      width: '50px',
      align: 'center',
      fixed: 'left',
      onCell: onRowClick,  
      render: (text, record, index) => {
        return (
          index+1
        )
      }        
    },  
    {
      title: '회사명',
      dataIndex: 'company_name',
      key: 'company_name',
      width: '130px',
      align: 'center', 
      ellipsis: true,  
      fixed: 'left', 
      sorter: (a, b) => a.company_name.localeCompare(b.company_name),
      onCell: onRowClick,  
      render: (company_name, record) => {
        return record.company_srl && record.edu_srl?
          <a onClick={(e) => {
            e.stopPropagation();
            open(CompanyEditModal, {
              id: record.company_srl,
              isPopup: true,
              onClose: (isOk) => {if(isOk) refetch();},
            }); 
          }}>
            <label style={{color:'black'}}>{company_name}</label>
          </a>:<label style={{color:'red'}}>{company_name}</label>        
      }          
    },  
    {
      title: '부서명',
      dataIndex: 'department',
      key: 'department',
      width: '120px',
      align: 'center',
      fixed: 'left',
      ellipsis: true,
      onCell: onRowClick,  
      sorter: (a, b) => a.department.localeCompare(b.department),
    },
    {
      title: '이름',
      dataIndex: 'name_kor',
      key: 'name_kor',
      width: '90px',
      align: 'center',
      fixed: 'left',
      ellipsis: true,  
      onCell: onRowClick,  
      sorter: (a, b) => a.name_kor.localeCompare(b.name_kor),
      render: (name_kor, record) => {
        return (
          <>
            {(record.memo)?(
              <Tooltip placement="topLeft" title={record.memo}>
                <CarryOutOutlined />&nbsp;{name_kor}
              </Tooltip>
              
            ):(name_kor)}
            {(record.memo3 !== '0')&&(<WarningOutlined style={{color:"red",marginLeft:"5px"}} />)}
          </>
        )
      }  
    }, 
    {
      title: '직위',
      dataIndex: 'position',
      key: 'position',
      width: '120px',
      align: 'center',
      fixed: 'left',
      ellipsis: true,
      onCell: onRowClick,  
    },
    {
      title: '직책',
      dataIndex: 'duty',
      key: 'duty',
      width: '120px',
      align: 'center',
      fixed: 'left',
      ellipsis: true,      
      onCell: onRowClick,  
    },          
    {
      title: '휴대폰',
      dataIndex: 'phone',
      key: 'phone',
      width: '100px',
      align: 'center',
      ellipsis: true,  
      onCell: onRowClick,  
      render: (phone) => {
        return (
          phone&&phone.toString().replace(/^(\d{2,3})(\d{3,4})(\d{4})$/, `$1-$2-$3`)
        )
      } 
    },    
    {
     title: '이메일',
     dataIndex: 'email',
     key: 'email',
     width: '150px',
     align: 'center',
     ellipsis: true,   
     onCell: onRowClick,  
   },
  {
    title: '메일발송현황',
    children: [
      {
        title: '교육담당자',
        dataIndex: 'mail_type06',
        key: 'mail_type06',
        width: '80px',
        align: 'center',
        onCell: (record) => {
          return {
              onClick: (e) => {
                e.stopPropagation();
                onSendMail(record.id, 'type06');
              },
          };
        },
        render: (text, record) => {
          const color = record.mail_type06_status==='40'?'#d9363e':record.mail_type06_status==='20'?'#52c41a':record.mail_type06_status==='30'?'#faad14':'black';
          return (
            <label style={{color:color}}>{text}</label>
          )
        }         
      },  
      {
        title: '신청확인',
        dataIndex: 'mail_type07',
        key: 'mail_type07',
        width: '80px',
        align: 'center',
        onCell: (record) => {
          return {
              onClick: (e) => {
                e.stopPropagation();
                onSendMail(record.id, 'type07');
              },
          };
        },
        render: (text, record) => {
          const color = record.mail_type07_status==='40'?'#d9363e':record.mail_type07_status==='20'?'#52c41a':record.mail_type07_status==='30'?'#faad14':'black';
          return (
            <label style={{color:color}}>{text}</label>
          )
        }           
      },  
      {
        title: '참석안내',
        dataIndex: 'mail_type09',
        key: 'mail_type09',
        width: '80px',
        align: 'center',
        onCell: (record) => {
          return {
              onClick: (e) => {
                e.stopPropagation();
                onSendMail(record.id, 'type09');
              },
          };
        },
        render: (text, record) => {
          const color = record.mail_type09_status==='40'?'#d9363e':record.mail_type09_status==='20'?'#52c41a':record.mail_type09_status==='30'?'#faad14':'black';
          return (
            <label style={{color:color}}>{text}</label>
          )
        }          
      },    
      {
        title: '현황공유',
        dataIndex: 'mail_type12',
        key: 'mail_type12',
        width: '80px',
        align: 'center',
        onCell: (record) => {
          return {
              onClick: (e) => {
                e.stopPropagation();
                onSendMail(record.id, 'type12');
              },
          };
        },
        render: (text, record) => {
          const color = record.mail_type12_status==='40'?'#d9363e':record.mail_type12_status==='20'?'#52c41a':record.mail_type12_status==='30'?'#faad14':'black';
          return (
            <label style={{color:color}}>{text}</label>
          )
        }           
      },    
      {
        title: '보고서전달',
        dataIndex: 'mail_type13',
        key: 'mail_type13',
        width: '80px',
        align: 'center',
        onCell: (record) => {
          return {
              onClick: (e) => {
                e.stopPropagation();
                onSendMail(record.id, 'type13');
              },
          };
        },
        render: (text, record) => {
          const color = record.mail_type13_status==='40'?'#d9363e':record.mail_type13_status==='20'?'#52c41a':record.mail_type13_status==='30'?'#faad14':'black';
          return (
            <label style={{color:color}}>{text}</label>
          )
        }          
      },   
    ]
  },   
 {
  title: '담당자명',
  dataIndex: 'edu_name',
  key: 'edu_name',
  width: '80px',
  align: 'center',
  ellipsis: true,    
  onCell: onRowClick,  
  sorter: (a, b) => a.edu_name.localeCompare(b.edu_name),   
},    
{
  title: '담당자직급',
  dataIndex: 'edu_position',
  key: 'edu_position',
  width: '80px',
  align: 'center',
  ellipsis: true,  
  onCell: onRowClick,  
  sorter: (a, b) => a.edu_position.localeCompare(b.edu_position),      
},    
{
  title: '담당자전화',
  dataIndex: 'edu_phone',
  key: 'edu_phone',
  width: '100px',
  align: 'center',
  ellipsis: true,  
  onCell: onRowClick,     
  render: (phone) => {
    return (
      phone&&phone.toString().replace(/^(\d{2,3})(\d{3,4})(\d{4})$/, `$1-$2-$3`)
    )
  } 
},    
{
  title: '담당자이메일',
  dataIndex: 'edu_email',
  key: 'edu_email',
  width: '150px',
  align: 'center',
  ellipsis: true,  
  onCell: onRowClick,     
},    
  ];

  /* ======================================================
  * hooks
  * ====================================================== */

  /* ======================================================
  * events
  * ====================================================== */  

  const onSendMail = (id: number, mail_type: string) => {          
    if (!!info) {
        open(B2cMailSendModal, {
            id: id,
            group: group,
            mail_type: mail_type,
            onClose: (isOk) => {
              if (isOk) {
                refetch();
              };
            },
        });  
    }
  }   

  const onHistoryOpen = (name: string, phone: string) => {          
    open(StudentHistoryModal, {
      name_kor: name,
      phone: phone,
    }); 
  }     

  const rowSelection = {
    selectedRowKeys,
    onChange: (selectedRowKeys: React.Key[], selectedRows: StudentListDto[]) => {
      setRowKeys(selectedRowKeys);
      
      setSelectd(selectedRows.map((item) => item.id));
      setSelectdStudent(selectedRows.map((item) => item.name_kor));
    },
  };  

  const onSendMultiSms = () => {   
    if (!!selected && selected.length > 0) {
        open(B2cMultiSmsSendModal, {
            ids: selected.join(','),
            toStudents: selectedStudent?.join(',')+'',
            onClose: (isOk) => {
              if (isOk) {   
                setRowKeys([]);                
              };
            },
        });  
    } else {
      alert("대상을 선택해 주세요.");
    }
  }   

  /* ======================================================
   * render items
   * ====================================================== */
  return (
    <Space direction="vertical" style={{ width: '100%' }}>
        <TableWrapper isSearch={false}>
          <div style={{ marginTop: 20, display:'flex', justifyContent:'space-between' }}>
            <h4><UnorderedListOutlined />&nbsp;보강자 목록</h4>
            <Button size='small' icon={<SendOutlined />} onClick={onSendMultiSms}>문자발송</Button>
          </div>          
          <Table
            tableLayout="fixed"
            scroll={{ x: 1450 }}
            dataSource={studentList}
            columns={columns}
            pagination={false}
            style={{ width: '100%', overflowX: 'auto', minWidth: 600 }}
            className="columnCenterFixTable clickable"
            showSorterTooltip={false}
            rowKey={'id'}
            rowSelection={{
              type: 'checkbox',
              ...rowSelection,
            }} 
          />
        </TableWrapper> 
    </Space>
  );
};

export default ReinforceTable;
